module.exports = __webpack_public_path__ + "static/img/fault-light-top.d7ffb9c5.png";